import $ from 'jquery';
import {MDCSnackbar} from '@material/snackbar';


export default class {
  constructor() {
    this.init();
  }

  init() {
    $('#attachment').change(function () {
      let file = $('#attachment')[0].files[0].name;
      $('#uploaded-file-name').text(file);
    });

    $('#comment').on('keyup', function () {
      let comment = $(this).val().trim();
      let submitButton = $('.comments input.submit');
      if (comment.length > 0) {
        submitButton.removeAttr('disabled');
      } else {
        submitButton.attr('disabled', 'true');
      }
    });

    // Show snackbar with 'create account' message if user focuses any comment field and is not auth'd
    var messageShown = false;
    $('.comment-form input, .comment-form textarea').on('focus', function(e) {
      e.preventDefault();

      if (messageShown) { return; }

      if ( window._env.current_user_id == 0 ) { // User not logged in
        
		const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));
		const snackbarActionButton = document.querySelector('.mdc-snackbar__action');
		snackbarActionButton.addEventListener('click', function(e) {
			console.log(e);
			window.location = '/quiz/food';
		});
		snackbar.labelText = 'Ah, you\'ll need to create a free account to share a rating.';
		snackbar.actionButtonText = 'Create Account';
		snackbar.open();
        
        messageShown = true;

        // Reset message display
        setTimeout(function(){
          messageShown = false;
        }, 3000);

        return;
      }
      $(this).trigger('click');
    });
  }
}


// WEBPACK FOOTER //
// ./scripts/modules/commentUpload.js